<!-- header -->
@if (isScheduleLoadingSignal()) {
  <!-- header loading skeletons-->
  @for (item of columnLoadingSkeletons; track $index) {
    <div class="h-4 animate-pulse rounded-xl bg-background-light-grey"></div>
  }
} @else {
  @for (el of operatories; track $index) {
    <div class="flex items-center">
      <div class="typo-h8-light flex-1 truncate rounded-xl bg-background-light-grey px-1 py-0.5 text-center uppercase text-text-primary">
        {{ el.operatoryName }}
      </div>
    </div>
  }
}
